import { LovewallSubscription } from "../../types/subscription";
import { generateAPI } from "../api.generator";

export const getLovewallSubscription = generateAPI<
  {},
  LovewallSubscription
>("get", "subscriptions/lovewall");
